// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__uVq1S","row":"Node_row__1YO8m","label":"Node_label__31d8-","footer":"Node_footer__1_iDH"};